import React from 'react';

import { Skeleton } from '@actualtysoft/ui-kit';
import {
  Paper,
  Table,
  TableBody,
  TableContainer,
  TableHead,
} from '@mui/material';

const ListSkeleton = () => {
  return (
    <TableContainer component={Paper}>
      <Table>
        <TableHead>
          <Skeleton
            type="body1"
            numberOfCells={5}
            numberOfRows={1}
            mode="table"
          />
        </TableHead>
        <TableBody>
          <Skeleton
            type="h2"
            numberOfCells={5}
            numberOfRows={10}
            mode="table"
          />
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default ListSkeleton;
